import { gql } from '@apollo/client';

export const DELETE_PEOPLE = gql`
  mutation DeletePeople($inputs: DeleteStakeholderInput) {
    people: deleteStakeholder(inputs: $inputs) {
      id
      name
    }
  }
`;
